var React = require('react');

function Vue (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"vue-logo-title","key":0},"Vue Js logo"),React.createElement("path",{"d":"M1538.7 0L1250 500 961.3 0H0l1250 2165.1L2500 0z","fill":"#4dba87","key":1}),React.createElement("path",{"d":"M1538.7 0L1250 500 961.3 0H500l750 1299L2000 0z","fill":"#435466","key":2})]);
}

Vue.defaultProps = {"viewBox":"0 0 2500 2165.1","aria-labelledby":"vue-logo-title"};

module.exports = Vue;

Vue.default = Vue;
